import { Typography } from '@repo/ui/Typography';
import { getCardsApprovalOddsValues } from '../../lib/approvalOdds';
import CardsApprovalOdds from './CardsApprovalOdds';
export const getCardsApprovalOddsDriver = (approvalOdds: string, isLoading: boolean) => {
  const approvalLikelihood = getCardsApprovalOddsValues(approvalOdds);
  return {
    label: 'Your approval odds',
    value: <CardsApprovalOdds approvalLikelihood={approvalLikelihood} isLoading={isLoading} />,
    labelTooltip: <Typography variant="text.small">
        We think your odds of getting approved for this card are{' '}
        <Typography as="span" variant="text.bold">
          {approvalLikelihood?.label ?? ''}{' '}
        </Typography>
        based on your credit score and other factors from your TransUnion credit report. That said,
        these odds are an estimate to help you narrow your choices, not a guarantee. Card issuers
        use different criteria than we do.
      </Typography>,
    valueTooltipHasHtml: true
  };
};